import {CsBaseComponent} from "../cs-base-component/cs-base-component";

// @ts-ignore
import template from './cs-spotlight-item.html';

class CsSpotlightItem extends CsBaseComponent {
    static acceptedAttributes: string[] = ['open', 'poster', 'title', 'date',
        'align', 'postTag', 'postTagColor', 'imageRadius'];

    static get observedAttributes() {
        return this.acceptedAttributes;
    }

    getTemplate(): string {
        return template;
    }

    applyStyles() {
        const htmlElement: HTMLElement|null = this.querySelector(`#${this.elementId}`);

        if (htmlElement) {
            const imageElement: HTMLElement|null = htmlElement.querySelector('#image');

            if (!this.getAttribute('open')) {
                htmlElement.style.cursor = 'default';
            }

            if (imageElement) {
                if (!this.getAttribute('poster')) imageElement.style.display = 'none';
                if (this.getAttribute('imageRadius') !== null) imageElement.style.borderRadius = (this.getAttribute('imageRadius') ?? 0) + 'px';

                imageElement.style.backgroundImage = `url(${this.getAttribute('poster')})`;
                imageElement.style.backgroundSize = 'cover';
                imageElement.style.backgroundPosition = 'center';
                imageElement.style.backgroundRepeat = 'no-repeat';
            }
        }
    }

    addEventListeners() {
        this.addEventListener('click', () => {
            const navigateUrl = this.getAttribute('open');
            if (navigateUrl) this.navigateByUrl(navigateUrl);
        });
    }

    navigateByUrl(url: string) {
        const target = this.getAttribute('target') || '_self';

        if (target === '_self') {
            window.location.href = url;
        } else {
            window.open(url, target);
        }
    }
}

customElements.define('cs-spotlight-item', CsSpotlightItem);
